// Lucide icons (VIS-05) as static SVG markup: the labor chips are HTML strings
// rendered by a Bryntum itemTpl, so both chip renderers share these strings
// instead of the lucide-react components. Path data: lucide-react 0.545
// (triangle-alert, clock), ISC licence.
const svg = (body) =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true">${body}</svg>`;

export const CHIP_ICON_SVG = {
  warning: svg('<path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"/><path d="M12 9v4"/><path d="M12 17h.01"/>'),
  clock: svg('<path d="M12 6v6l4 2"/><circle cx="12" cy="12" r="10"/>'),
};
